import CarouselBlock from './CarouselBlock';
export { CarouselBlockContainer } from './CarouselBlockContainer';
export default CarouselBlock;
